// extracted by mini-css-extract-plugin
export default {"cardView":"styles_cardView__ZGXCx","cardTitle":"styles_cardTitle__DUi1w","cardDiscription":"styles_cardDiscription__6TCaC"};